import React from 'react';
import { useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();
  const isInterviewPage = location.pathname === '/admin/interview';
  const isAdminPage = location.pathname.startsWith('/admin');
  
  // Don't show footer on interview page
  if (isInterviewPage) {
    return null;
  }
  
  return (
    <footer className={`${isAdminPage ? 'fixed bottom-0 left-64 right-0' : 'relative'} bg-white border-t border-gray-200 z-40`}>
      <div className="px-6 py-3">
        <div className="flex items-center justify-between text-xs text-gray-500">
          <div className="flex items-center space-x-4">
            <span>© {new Date().getFullYear()} DriveManager. All rights reserved.</span>
            <span>•</span>
            <span>Version 1.0.0</span>
          </div>
          <div className="flex items-center space-x-2">
            <span>Engineered with ❤️ by </span>
            <a
              href="https://www.quacklabs.in"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
            >
              Quacklabs
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
